export default __webpack_public_path__ + "static/media/route-start.06a4da22.svg";